export default [
  {
    path: "/event/poster",
    name: "mgzfposter",
    meta: {
      title: "蘑菇租房"
    },
    component: () => System.import("@/pages/events/poster.vue")
  },
  {
    path: "/event/goallout",
    name: "goAllOut",
    meta: {
      title: "券力以付"
    },
    component: () => System.import("@/PagesAreaEvents/cardGoAllOut/index.vue"),
    beforeEnter: (to, from, next) => {
      next();
    }
  },
  {
    path: "/event/couponHelp",
    name: "couponHelp",
    meta: {
      title: "蘑菇租房红包卡券为好友助力"
    },
    component: () => System.import("@/PagesAreaEvents/couponHelp/index.vue")
  },
  {
    path: "/event/customized/:type/:step",
    name: "customized",
    component: () => System.import("@/PagesAreaEvents/customized/index.vue")
  },
  {
    path: "/event/paydayLoan",
    name: "paydayLoan",
    meta: {
      title: "借款"
    },
    component: () => System.import("@/PagesAreaEvents/paydayLoan")
  },
  {
    path: "/event/rentalCarnival",
    name: "rentalCarnival",
    meta: {
      title: "蘑菇618租房狂欢节"
    },
    component: () => System.import("@/PagesAreaEvents/rentalCarnival")
  },
  {
    path: "/event/rentalBrand",
    name: "rentalBrand",
    component: () => System.import("@/PagesAreaEvents/rentalCarnival/brand")
  },
  {
    path: "/event/rentalSignUp",
    name: "rentalSignUp",
    component: () => System.import("@/PagesAreaEvents/rentalCarnival/signUp")
  },
  {
    path: '/event/instantFindRoomRecommend',
    name: 'recommend',
    meta: {
      title: '推荐列表'
    },
    component: () => System.import("@/PagesAreaEvents/instantFindRoom/recommend")
  },
  {
    path: '/event/instantFindRoomSearch',
    name: 'instantFindRoomSearch',
    meta: {
      title: '一键租房'
    },
    component: () => System.import('@/PagesAreaEvents/instantFindRoom/searchIndex')
  },
  {
    path: '/:city/event/instantFindRoomRecommend',
    name: 'recommendCity',
    meta: {
      title: '推荐列表'
    },
    component: () => System.import("@/PagesAreaEvents/instantFindRoom/recommend")
  },
  {
    path: '/:city/event/instantFindRoomSearch',
    name: 'instantFindRoomSearchCity',
    meta: {
      title: '一键租房'
    },
    component: () => System.import('@/PagesAreaEvents/instantFindRoom/searchIndex')
  },
  {
    path: '/event/thousandOne',
    name: 'thousandOne',
    meta: {
      title: '千元性价比好房 租出新生活'
    },
    component: () => System.import('@/PagesAreaEvents/instantFindRoom/thousandOne')
  },
  {
    path: '/event/thousandSearch',
    name: 'thousandSearch',
    meta: {
      title: '填写租房需求'
    },
    component: () => System.import('@/PagesAreaEvents/instantFindRoom/thousandSearch')
  },
  {
    path: '/event/thousandTwo',
    name: 'thousandTwo',
    meta: {
      title: '找到靠谱的好房源'
    },
    component: () => System.import('@/PagesAreaEvents/instantFindRoom/thousandTwo')
  },
  {
    path: '/event/thousandThree',
    name: 'thousandThree',
    meta: {
      title: '千元性价比好房 租出新生活'
    },
    component: () => System.import('@/PagesAreaEvents/instantFindRoom/thousandThree')
  },
  {
    path: '/event/thousandFiveSeconds',
    name: 'thousandFiveSeconds',
    meta: {
      title: '千元性价比好房',
      keepAlive: true
    },
    component: () => System.import('@/PagesAreaEvents/thousandFiveSeconds/index')
  },
  {
    path: "/event/7room",
    name: "7room",
    meta: {
      title: "命中“住”定我爱你",
      keepAlive: true
    },
    component: () => System.import("@/PagesAreaEvents/7room")
  },
  {
    path: "/event/7room/sign",
    name: "7roomSign",
    meta: {
      title: "我要入住",
      keepAlive: true
    },
    component: () => System.import("@/PagesAreaEvents/7room/sign")
  },
  {
    path: "/event/7room/nameList",
    name: "7roomNameList",
    meta: {
      title: "入选名单"
    },
    component: () => System.import("@/PagesAreaEvents/7room/nameList")
  },
  {
    path: "/event/7room/list",
    name: "7roomList",
    meta: {
      title: "情侣房特惠专区"
    },
    component: () => System.import("@/PagesAreaEvents/7room/list")
  },
  {
    path: "/event/7room/rule",
    name: "7roomRule",
    meta: {
      title: "活动细则及条款"
    },
    component: () => System.import("@/PagesAreaEvents/7room/rule")
  },
  {
    path: "/event/7room/xy",
    name: "7roomxy",
    meta: {
      title: "命中“住”定我爱你"
    },
    component: () => System.import("@/PagesAreaEvents/7room/xy")
  },
  {
    path: "/event/jdFinance",
    name: "jdFinance",
    meta: {
      title: "免费租房 了解一下"
    },
    component: () => System.import("@/PagesAreaEvents/jingDongFinance")
  },
  {
    path: "/event/jdFinance/sign",
    name: "jdFinanceSign",
    meta: {
      title: "我要入住",
      keepAlive: true
    },
    component: () => System.import("@/PagesAreaEvents/jingDongFinance/sign")
  },
  {
    path: "/event/jdFinance/nameList",
    name: "jdFinanceNameList",
    meta: {
      title: "入选名单"
    },
    component: () => System.import("@/PagesAreaEvents/jingDongFinance/nameList")
  },
  {
    path: "/event/jsFinance/rule",
    name: "jdFinanceRule",
    meta: {
      title: "活动细则及条款"
    },
    component: () => System.import("@/PagesAreaEvents/jingDongFinance/rule")
  },
  {
    path: '/event/tejiafang',
    name: 'tejiafang',
    meta: {
      title: '蘑菇8折特价房'
    },
    component: () => System.import('@/PagesAreaEvents/tejiafang/index')
  },
  {
    path: '/event/activity/template',
    name: '',
    meta: {
      title: ''
    },
    component: () => System.import('@/PagesAreaEvents/activityTemplate/index')
  },
  {
    path: "/event/receiveRedEnvelope",
    name: "receiveRedEnvelope",
    meta: {
      title: "天天领红包"
    },
    component: () => System.import("@/PagesAreaEvents/receiveRedEnvelope/")
  },
  {
    path: "/:city?/event/rentalHoliday",
    name: "rentalHoliday",
    meta: {
      title: "蘑菇租房节"
    },
    component: () => System.import("@/PagesAreaEvents/rentalHoliday/")
  },
  {
    path: "/event/rentalHoliday/rule",
    name: "rentalHolidayRule",
    meta: {
      title: "蘑菇租房节"
    },
    component: () => System.import("@/PagesAreaEvents/rentalHoliday/rule")
  },
  {
    path: "/event/rentalHoliday/my",
    name: "rentalHolidayMy",
    meta: {
      title: "我的奖品"
    },
    component: () => System.import("@/PagesAreaEvents/rentalHoliday/my")
  },
  {
    path: "/event/rentalHoliday/ListIndex/:type",
    name: "rentalHolidayListIndex",
    meta: {
      title: "蘑菇租房节"
    },
    component: () => System.import("@/PagesAreaEvents/rentalHoliday/listIndex")
  },
  {
    path: "/event/leaseLottery/index",
    name: "leaseLotteryIndex",
    meta: {
      title: "评价抽奖"
    },
    component: () => System.import("@/PagesAreaEvents/leaseLottery/index")
  },
  //咸鱼领取礼包
  {
    path: "/event/xianyuGift/index",
    name: "xianyuGiftIndex",
    meta: {
      title: "领取礼包"
    },
    component: () => System.import("@/PagesAreaEvents/xianyuGift/index")
  },
  //  活动模板  会场
  {
    path: "/event/commonTmp",
    name: "commonTmpHome",
    component: () => System.import("@/PagesAreaEvents/commonTmp/index")
  },
  {
    path: "/event/commonTmp/sign",
    name: "commonTmpSign",
    meta: {
      keepAlive: true
    },
    component: () => System.import("@/PagesAreaEvents/commonTmp/sign")
  },
  {
    path: "/event/commonTmp/rule",
    name: "commonTmpRule",
    component: () => System.import("@/PagesAreaEvents/commonTmp/rule")
  },
  {
    path: "/event/commonTmp/winners",
    name: "commonTmpWinners",
    component: () => System.import("@/PagesAreaEvents/commonTmp/winners")
  },
  {
    path: "/event/christmasActivities/charistmasIndex",
    name: "charistmasIndex",
    meta: {
      title: "圣诞不孤单",
      keepAlive: true
    },
    component: () => System.import("@/PagesAreaEvents/christmasActivities/charistmasIndex")
  },
  {
    path: "/event/christmasActivities/couponList",
    name: "couponList",
    meta: {
      title: "圣诞不孤单"
    },
    component: () => System.import("@/PagesAreaEvents/christmasActivities/couponList")
  },
  {
    path: "/event/christmas",
    name: "christmasHome",
    meta: {
      title: "圣诞不孤单",
      keepAlive: true
    },
    component: () => System.import("@/PagesAreaEvents/christmasActivities/index")
  },
  {
    path: "/event/christmas/rule",
    name: "christmasRule",
    meta: {
      title: "圣诞不孤单",
      keepAlive: true
    },
    component: () => System.import("@/PagesAreaEvents/christmasActivities/rule")
  },
  {
    path: "/event/christmas/sign",
    name: "christmasSign",
    meta: {
      title: "圣诞不孤单",
      keepAlive: true
    },
    component: () => System.import("@/PagesAreaEvents/christmasActivities/sign")
  },
  {
    path: "/event/christmas/winners",
    name: "christmasWinners",
    meta: {
      title: "圣诞不孤单",
      keepAlive: true
    },
    component: () => System.import("@/PagesAreaEvents/christmasActivities/winners")
  },
  //超级大牌月
  {
    path: "/:city?/event/dpmonth",
    name: "dpmonth",
    meta: {
      title: "超级大牌月"
    },
    component: () => System.import("@/PagesAreaEvents/dpMonth")
  },
  {
    path: "/event/eventCityMenu",
    name: "eventCityMenu",
    component: () => System.import("@/PagesAreaEvents/eventsCityMenu")
  },
  {
    path: "/event/cmsTmp/index",
    name: "commonTmpIndex",
    component: () => System.import("@/PagesAreaEvents/cmsTmp/index")
  },
  {
    path: "/event/cmsTmp/lableRoomList",
    name: "lableRoomList",
    meta: {
      title: "列表页",
      keepAlive: true
    },
    component: () => System.import("@/PagesAreaEvents/cmsTmp/lableRoomList")
  },
  {
    path: "/event/cmsTmp/brandsList",
    name: "brandsList",
    meta: {
      title: "列表页",
      keepAlive: true
    },
    component: () => System.import("@/PagesAreaEvents/cmsTmp/brandsList")
  }
];



// WEBPACK FOOTER //
// ./src/router/events.js